import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import App from './App';
import theme from './theme';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement!);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      <GlobalStyles
        styles={{
          ':root': {
            '--E4E4E4': '#E4E4E4',
            '--7D7D7D': '#7D7D7D',
            '--D91E18': '#D91E18',
            '--C11A16': '#C11A16',
            '--A71414': '#A71414',
            '--input-color': '#242424',
            // '--input-bg-color': 'rgba(0, 0, 0, 0.40)',
            '--modal-bg-color': '#fff',
          },
          html: {
            height: '100%',
            fontSize: '10px',
          },
          body: {
            height: '100%',
            backgroundColor: '#fff',
          },
        }}
      />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
